// Copyright © 2021 Move Closer

import { TeaserBoxInnerGrid } from '../TeaserBox.contracts'
// import { TeaserBoxInnerGrid6SBigThumbnailsList } from './deprecated/6S-big-thumbnails-list'
// import { TeaserBoxInnerGrid6SThumbnailsList } from './deprecated/6S-thumbnails-list'
// import { TeaserBoxInnerGrid6TTextList } from './deprecated/6T-text-list'
// import { TeaserBoxInnerGrid8T } from './deprecated/8T'
// import { TeaserBoxInnerGridL2SBigThumbnailsList } from './deprecated/L-2S-big-thumbnails-list'
// import { TeaserBoxInnerGridL2STextList } from './deprecated/L-2S-text-list'
// import { TeaserBoxInnerGridL2SThumbnailsList } from './deprecated/L-2S-thumbnails-list'
// import { TeaserBoxInnerGridL4S } from './deprecated/L-4S'
// import { TeaserBoxInnerGridL8S } from './deprecated/L-8S'
// import { TeaserBoxInnerGridL5STextList } from './deprecated/L-5S-text-list'

import { TeaserBoxInnerGrid1XL } from './1XL'
import { TeaserBoxInnerGrid2L } from './2L'
import { TeaserBoxInnerGrid6STextList } from './6S-text-list'
import { TeaserBoxInnerGrid8S } from './8S'
import { TeaserBoxInnerGrid4S } from './4S'
import { TeaserBoxInnerGridL4STextList } from './L-4S-text-list'
import { TeaserBoxInnerGridL4STextListTabs } from './L-4S-text-list-tabs'
import { TeaserBoxInnerGridXL3STextList } from './XL-3S-text-list'
import { TeaserBoxInnerGridXLSlider3STextList } from './XL-slider-3S-text-list'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const teaserBoxInnerGrids: Array<typeof TeaserBoxInnerGrid> = [
  TeaserBoxInnerGrid1XL,
  TeaserBoxInnerGrid2L,
  TeaserBoxInnerGrid6STextList,
  TeaserBoxInnerGrid8S,
  TeaserBoxInnerGrid4S,
  TeaserBoxInnerGridL4STextList,
  TeaserBoxInnerGridL4STextListTabs,
  TeaserBoxInnerGridXL3STextList,
  TeaserBoxInnerGridXLSlider3STextList
  // TeaserBoxInnerGrid6SBigThumbnailsList,
  // TeaserBoxInnerGrid6SThumbnailsList,
  // TeaserBoxInnerGrid6TTextList,
  // TeaserBoxInnerGrid8T,
  // TeaserBoxInnerGridL2SBigThumbnailsList,
  // TeaserBoxInnerGridL2STextList,
  // TeaserBoxInnerGridL2SThumbnailsList,
  // TeaserBoxInnerGridL4S,
  // TeaserBoxInnerGridL8S,
  // TeaserBoxInnerGridL5STextList,
]
